import { createApp } from 'vue'
import App from './App.vue'
import Payments from "./components/Payments.vue";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';


import { createRouter, createWebHistory } from "vue-router"

const routes = [
  { path: "/", component: Payments },
  { path: "/payments", component: Payments }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

createApp(App)
  .use(router)
  .use(VueSweetalert2)
  .mount('#app')
